<script setup lang="ts">
interface Props {
  posts: any[];
  title: string;
  description?: string;
  category?: string;
  showBlogLink?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showBlogLink: true,
});
</script>

<template>
  <ArticlesArticleHero
    :title="title"
    :category="category"
    :show-blog-link="showBlogLink"
    class="mb-10"
  />

  <UContainer class="page-container max-w-full xl:!max-w-[90rem]">
    <UPage>
      <UPageBody class="page-body">
        <!-- Description -->
        <div v-if="description" class="mb-8">
          <p class="text-gray-600 dark:text-gray-400">
            {{ description }}
          </p>
        </div>

        <!-- Articles list -->
        <UBlogList>
          <UBlogPost
            v-for="(post, index) in posts"
            :key="index"
            :to="post.path"
            :title="post.title"
            :image="post.image"
            :date="
              new Date(post.date).toLocaleDateString('en', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              })
            "
            :authors="post.authors as any"
            :badge="post.badge as any"
            :description="post.description"
            :orientation="index === 0 ? 'horizontal' : 'vertical'"
            :class="[index === 0 && 'col-span-full', 'relative']"
            :ui="{
              description: 'line-clamp-2',
            }"
          />
        </UBlogList>
      </UPageBody>

      <!-- Sidebar -->
      <template #right>
        <UContentToc
          :title="'Browse by Category'"
          :links="[]"
          :ui="{
            wrapper: 'sticky top-[calc(var(--header-height)+2rem)]',
          }"
        >
          <template #bottom>
            <p class="text-sm bold-bold truncate">Browse by Category:</p>
            <div class="pt-4 border-t border-gray-200 dark:border-gray-800 mt-4">
              <CategoryNav mode="list" size="default" :hide-all-articles="false" />
            </div>
          </template>
        </UContentToc>
      </template>
    </UPage>
  </UContainer>
</template>

<style scoped>
/* Ensure UBlogPost container has relative positioning for absolute overlays */
:deep(.group) {
  position: relative;
}

/* Only disable pointer events on decorative overlays, not the main article link */
:deep(.absolute.inset-0[aria-hidden='true']:not(a .absolute.inset-0)) {
  pointer-events: none;
}
</style>
